import './css/dashboardtable.css';
import React, { useState,useEffect} from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';
import Landing from '../Landing';




function AllVideos(){


        
    useEffect(() => {
        axios
    .get('session-admin')
    .then((res) => {
        if (res.data.valid) {

            if(res.data.type == "admin"){

            }else{
                navigate('/admin-login');
            }

        } else {

        }
    })
    .catch((err) => console.log(err));
    },[]);



    
    const navigate = useNavigate();
    const [AllVideos, setAllVideos] = useState([]);

    axios.defaults.withCredentials = true;





    const getAllVideos = ()=>{
        axios.post('AllItems', {
            table: 'videos',
        })
        .then((res) => {
            if (res.data) {
                console.log(res.data)
                setAllVideos(res.data);
            } else {
                console.log("Error happened");
            }
        })
        .catch((err) => console.log(err));
    };
    




    const getIfLogin= ()=>{
        
    axios
    .get('session')
    .then((res) => {
        if (!res.data.valid) {
            console.log(res.data.valid);
            navigate('/admin-login');

        }else{
            console.log(res.data.valid);

        }
    })
    .catch((err) => console.log(err));

    }





    const deleteItem = (id) => {
        axios
        .delete(`delete-item/${id}`, {
            data: {
            table: 'videos',
            },
        })
        .then((response) => {
            if (response.data.message === 'Item deleted successfully') {
                getAllVideos();
            } else {
            console.error('Failed to delete result:', response.data.message);
            }
        })
        .catch((error) => {
            console.error('Error deleting result:', error);
        });
    };




useEffect(() => {

    getAllVideos();
    getIfLogin();

}, []);




    

    return(
        <>
            <section className='dashboard'>



                <div className='results-table'>
                <Link className='new-item' to='/add-video'> +  فيديو جديد</Link>
                <table>

                    <thead>
                        <tr>
                            <th>ID</th>
                            <th> العنوان </th>


                            <th>الخيارات</th>

                        </tr>
                    </thead>
                    <tbody>
                    {AllVideos.length ? (

                    AllVideos.map(video => {

                        return (
                            <tr key={video.id}>
                            <td><h6>{video.id}</h6></td>

                            <td><h6>{video.video_src}</h6></td>







                            <td>
                                <Link className='edit' to={`/edit-video?id=${video.id}`}> <i class="las la-edit"></i> </Link>
                            </td>

                            
                            <td>
                                <button className='delete' onClick={() => deleteItem(video.id)}> <i class="las la-trash-alt"></i> </button>
                            </td>

                            </tr>
                        );
                        })): 
                        
                        
                        
                        (
                            <tr>
                                <td colSpan={5}>تحميل...</td>
                            </tr>
                            )}
                    </tbody>
                </table>

                </div>
            </section>
        
        </>
    )
}

export default AllVideos;